module.exports = __webpack_public_path__ + "img/SY.02c1d5b2.svg";